export var StoreTypeEnum;
(function (StoreTypeEnum) {
    StoreTypeEnum["MERCHANT"] = "merchant";
    StoreTypeEnum["STORE"] = "store";
    StoreTypeEnum["DEFAULT"] = "default";
})(StoreTypeEnum || (StoreTypeEnum = {}));
//# sourceMappingURL=store-type.enum.js.map